import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertTriangle, RefreshCw } from "lucide-react";

interface Props {
  title: string;
  onRetry: () => void;
  isForbidden?: boolean;
}

export function DashboardErrorTile({ title, onRetry, isForbidden }: Props) {
  return (
    <Card>
      <CardContent className="flex items-center gap-3 p-4">
        <AlertTriangle className="h-4 w-4 text-amber-500 shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-foreground">
            {isForbidden
              ? `You don't have access to ${title}`
              : `Couldn't load ${title}`}
          </p>
        </div>
        {!isForbidden && (
          <Button
            variant="outline"
            size="sm"
            onClick={onRetry}
            className="gap-1.5"
          >
            <RefreshCw className="h-3.5 w-3.5" /> Retry
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
